import { render, staticRenderFns } from "./commodityOrdersIndex.vue?vue&type=template&id=19a88fe6&scoped=true&"
import script from "./commodityOrdersIndex.vue?vue&type=script&lang=js&"
export * from "./commodityOrdersIndex.vue?vue&type=script&lang=js&"
import style0 from "./commodityOrdersIndex.vue?vue&type=style&index=0&id=19a88fe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a88fe6",
  null
  
)

export default component.exports